<div class="card card-danger">
  <div class="card-header">
    <div class="float-left"><h5> Customer Invoices </h5></div>
    <div class="float-right">
      <div class="btn-group" role="group" aria-label="Basic example">
        <button (click)="showFind()" type="button" class="btn btn-sm btn-outline-info"><i class="fa fa-search" aria-hidden="true"></i> Find</button>
        <button (click)="showNew()" type="button" class="btn btn-sm btn-outline-success"><i class="fa fa-plus" aria-hidden="true"></i> Add new </button>
      </div>
    </div>
  </div>

  <div class="card-body">
    <div class="row">
      <div class="col">

        <div *ngIf="mode==formModes.Find">
          <div class="row" style="margin-left: 0px;">
            <div class="col-sm-6">
              <div class="form-group row">
                <label for="BillingID" class="col-sm-3 col-form-label" style="position: relative; top: 6px;">Status</label>
                <div class="col-sm-9" style="margin-left: -64px; height: 0px;">
                  <mat-form-field appearance="outline">
                    <mat-label>Status</mat-label>
                    <input matInput [(ngModel)]="model.status" maxlength="50" type="text" id="Status" name="Status">
                  </mat-form-field>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <div class="text-center m-3">
                <button type="button" (click)="onSubmit()" class="btn btn-sm btn-info mx-1"><i class="fa fa-search" aria-hidden="true"></i> Search </button>
                <button type="button" class="btn btn-sm mx-1 " style="color: white; background-color: #2f72ab;" (click)="resetForm()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel </button>
              </div>
              <br />
            </div>
          </div>
        </div>

        <div *ngIf="mode==formModes.New || mode==formModes.Edit">
          <div>
            <form #f="ngForm" (ngSubmit)="onSubmit(f)">
              <!--<div class="row">-->

                <!-- <div class="col-sm-6">

                </div> -->

              <!--</div>-->
              <div class="row" style="margin-left: 40px">

                <div class="col-sm-6">
                  <div class="form-group row" style="margin-right: 140px">
                    <label for="ClientId" class="col-sm-3 col-form-label">
                      Client Master
                    </label>
                    <div class="col-sm-9">
                      <!-- <p-dropdown required [options]="clients" [(ngModel)]="model.ClientId" [filter]="true" filterBy="label" #clientId="ngModel" id="ClientId" name="ClientId" [autoWidth]="true" placeholder="Select client" [showClear]="true"></p-dropdown> -->
                      <mat-form-field appearance="outline">
                        <mat-label>Select client master</mat-label>
                        <mat-select [(ngModel)]="model.clientId" #clientId="ngModel" required id="ClientId" name="ClientId" >
                          <mat-option *ngFor="let client of clients" [value]="client.value">
                            {{client.label}}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                      <div *ngIf="clientId.invalid && (clientId.dirty || clientId.touched)" class="text-danger small">
                        <div *ngIf="clientId.errors.required">
                          Client Master is required.
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-group row" style="margin-right: 140px">
                    <label for="Name" class="col-sm-3 col-form-label">Total</label>
                    <div class="col-sm-9">
                      <mat-form-field appearance="outline">
                        <mat-label>Total</mat-label>
                        <input matInput [(ngModel)]="model.total" disabled #total="ngModel" type="number" id="Total" name="Total">
                      </mat-form-field>
                    </div>
                  </div>


                </div>
                <div class="col-sm-6">
                  <div class="form-group row">
                    <label for="Name" class="col-sm-3 col-form-label">Invoice Date</label>
                    <div class="col-sm-9">
                      <mat-form-field appearance="outline" style="width: 60%;">
                        <mat-label>Choose Invoice date</mat-label>
                        <input matInput required [(ngModel)]="model.invoiceDate" #invoiceDate="ngModel" id="InvoiceDate" name="InvoiceDate" [matDatepicker]="picker" style=" font-size: 14px;">
                        <mat-datepicker-toggle matSuffix [for]="picker">
                          <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
                        </mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                      </mat-form-field>
                      <div *ngIf="invoiceDate.invalid && (invoiceDate.dirty || invoiceDate.touched)" class="text-danger small">
                        <div *ngIf="invoiceDate.errors.required">
                          Invoice Date is required.
                        </div>
                        <div *ngIf="invoiceDate.errors.maxlength">
                          Invoice Date must be between {{mindate| date : 'mm-dd-yyyy'}} and {{maxdate| date : 'mm-dd-yyyy'}}
                        </div>
                      </div>

                    </div>
                  </div>
                  <div class="form-group row">
                    <label for="BillingID" class="col-sm-3 col-form-label">Status</label>
                    <div class="col-sm-9">
                      <mat-form-field appearance="outline">
                        <mat-label>Enter your Status</mat-label>
                        <mat-select [(ngModel)]="model.status" disabled #status="ngModel" required id="Status" name="Status">
                          <mat-option *ngFor="let statusOption of StatusOptions" [value]="statusOption.value">
                            {{statusOption.label}}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>

                      <div *ngIf="status.invalid && (status.dirty || status.touched)" class="text-danger small">
                        <div *ngIf="status.errors.required">
                          Status is required.
                        </div>
                        <div *ngIf="status.errors.maxlength">
                          Status must be less than 50 characters long.
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>

              <div class="row">
                <div class="col-sm-12">
                  <div class="text-center m-3">
                    <button type="button" *ngIf="model.status == 'Created' || model.status == 'Finalized' || model.status == 'Sent'" class="btn btn-sm btn-success mx-1" (click)="reGenerateCustomerInvoice(f, model)"> Finalize </button>
                    <button type="button" *ngIf="model.status == 'Finalized'" class="btn btn-sm btn-success mx-1" (click)="verifyAccountingToken(f, model)"> Generate Invoice </button>
                    <button *ngIf="mode==formModes.Edit && model.status == 'Created'|| model.status == 'Finalized'" type="button" class="btn btn-sm mx-1" (click)="openDialog('load')" [disabled]="disableAddTransaction" style="color: white; background-color: #2f72ab;"> Add Transactions </button>
                    <button *ngIf="mode==formModes.New && model.status != 'Sent' && model.status != 'Finalized'" type="button" class="btn btn-sm mx-1" (click)="openDialog('pull')" [disabled]="disableAddTransaction" style="color: white; background-color: #2f72ab;"> Add Transactions </button>
                    <button type="button" class="btn btn-sm mx-1" style="color: white; background-color: #2f72ab;" (click)="resetForm()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel </button>
                    <!--<button type="submit" [disabled]="f.invalid" *ngIf="mode==formModes.New && model.status != 'Sent'" class="btn btn-sm btn-success mx-1"><i class="fa fa-plus" aria-hidden="true"></i> Save </button>
  <button type="submit" [disabled]="f.invalid" *ngIf="mode==formModes.Edit && model.status != 'Sent'" class="btn btn-sm btn-outline-secondary mx-1"><i class="fa fa-floppy-o" aria-hidden="true"></i> Update </button>-->
                  </div>
                  <br />
                </div>
              </div>

              <div class="row" id="mainPageGrid">
                <div class="col">


                  <table style="overflow: auto;padding: 0px;" mat-table [dataSource]="TransactiondataSourceMainPage">
                    <ng-container matColumnDef="Transaction Date">
                      <th style="width : 15%" mat-header-cell *matHeaderCellDef> Transaction Date </th>
                      <td mat-cell *matCellDef="let element"> {{element.entryDate  | date:'shortDate'}} </td>
                    </ng-container>

                    <!-- Name Column -->
                    <ng-container matColumnDef="Tracking/Invoice number">
                      <th mat-header-cell *matHeaderCellDef style="width: 20%"> Tracking number </th>
                      <td mat-cell *matCellDef="let element"> {{element.masterTrackingNumber}} </td>
                    </ng-container>

                    <!-- Weight Column -->
                    <ng-container matColumnDef="Description of Charge">
                      <th style="align-items: center;padding : 1%" mat-header-cell *matHeaderCellDef> Charge Desc </th>
                      <td mat-cell style="padding : 1%" *matCellDef="let element"> {{element.description}} </td>
                    </ng-container>

                    <ng-container matColumnDef="netAmount">
                      <th mat-header-cell *matHeaderCellDef> Customer Charge</th>
                      <td style="width : 10%" mat-cell *matCellDef="let element">  {{element.netAmount}} </td>
                    </ng-container>

                    <ng-container matColumnDef="incentiveAmount">
                      <th style="width : 10%;padding: 1%;text-align: center;" mat-header-cell *matHeaderCellDef> Invoiced Amount </th>
                      <td style="padding: 1%;text-align: center;" *matCellDef="let element"> {{element.incentiveAmount}} </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="transactionColumnsMainPage"></tr>
                    <tr mat-row *matRowDef="let row; columns: transactionColumnsMainPage;">
                    </tr>
                  </table>
                  <div class="notabledata" *ngIf="TransactiondataSourceMainPage.data.length === 0">
                    <div style="margin-top: 5px">No Data Available For Display<br /></div>
                  </div>
                  <mat-paginator [pageIndex]="pageNumber" [pageSize]="pageSize" (page)="onPageChange($event)" [length]="pageLength" [pageSizeOptions]="[5,10,50, 100]" aria-label="Select page of users" ></mat-paginator>
             
                </div>

              </div>

            </form>
          </div>
        </div>

        <div *ngIf="mode==formModes.Del">
          <div class="row">
            <div class="col-sm-6">
              <div class="form-group row">
                <label for="ClientId" class="col-sm-3 col-form-label">
                  Client
                </label>
                <div class="col-sm-9">
                  <!-- <p-dropdown [options]="clients" [ngModel]="model.clientId" [filter]="true" filterBy="label" id="ClientId" name="ClientId" disabled [autoWidth]="true" placeholder="Select client" [showClear]="true"></p-dropdown> -->
                  <mat-form-field appearance="outline">
                    <mat-label>Select client</mat-label>
                    <mat-select [(ngModel)]="model.clientId" #clientId="ngModel" required id="ClientId" name="ClientId" disabled>
                      <mat-option *ngFor="let client of clients" [value]="client.value" disabled>
                        {{client.label}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <div class="text-center m-3">
                <button type="button" (click)="onSubmit()" class="btn btn-sm btn-danger mx-1"><i class="fa fa-times" aria-hidden="true"></i> Delete </button>
                <button type="button" (click)="resetForm()" class="btn btn-sm mx-1" style="color: white; background-color: #2f72ab;"><i class="fa fa-ban" aria-hidden="true"></i> Cancel </button>
              </div>
              <br />
            </div>
          </div>
        </div>

      </div>
    </div>

    <div *ngIf="mode !=formModes.New && mode !=formModes.Edit" class="row">
      <div class="col">
        <div class="row">
          <div class="col">
            <div class="mat-elevation-z8" style="position: relative; top: -15px;">
              <table mat-table [dataSource]="dataSource" matSort>


                <!-- <ng-container matColumnDef="Sno">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header> S.no </th>
                  <td mat-cell *matCellDef="let row;let i = index">{{ i + 1}}  </td>
                </ng-container> -->

                <ng-container matColumnDef="Total">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header> Total </th>
                  <td mat-cell *matCellDef="let row"> {{ row.total }} </td>
                </ng-container>

                <ng-container matColumnDef="Status">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header> Status </th>
                  <td mat-cell *matCellDef="let row">
                    {{ row.status }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="Date">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header> Date </th>
                  <td mat-cell *matCellDef="let row"> {{ row.invoiceDate | date :'MM-dd-yyyy' }} </td>
                </ng-container>

                <ng-container matColumnDef="Client">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header> Client </th>
                  <td mat-cell *matCellDef="let row">{{ clients | getLabelOf : row.clientMasterId }} </td>
                </ng-container>


                <ng-container matColumnDef="...">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header> ... </th>
                  <td mat-cell *matCellDef="let row">
                    <div class="btn-group btn-group-sm">
                      <button (click)="showEdit(row)" class="btn btn-sm btn-outline-primary"><i class="fa fa-pencil" aria-hidden="true"></i></button>
                      <button (click)="showDel(row)" class="btn btn-sm btn-outline-danger"><i class="fa fa-times" aria-hidden="true"></i></button>
                      <button (click)="verifyAccountingTokenForFileDownload(row.id)" class="btn btn-sm btn-outline-success"><i class="fa fa-cloud-download" aria-hidden="true"></i></button>

                    </div>
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
              </table>
              <span style="position: relative; left: 40%; font-size: 13px; top: 40px;">There are {{pageLengthh}} records</span>

              <mat-paginator  [pageIndex]="pageNum" [pageSize]="pageSizee" (page)="onPageEvent($event)" [length]="pageLengthh" [pageSizeOptions]="[5,10,50, 100]" aria-label="Select page of transactions" class="custom-paginator" ></mat-paginator>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>

<ng-template #callAddTransacationDialog>
  <div style="width : 700px;height: 500px; overflow-x:auto; overflow-y:auto;">
    <mat-dialog-content >
      <h1 mat-dialog-title style="text-align: center;">
        Add Transactions
        <button mat-icon-button
                mat-dialog-close
                color="warm"
                style="float: right; display: flex; justify-content: center;" (click)="close()">
          <mat-icon style="font-size: 20px; margin-right: -33px;">close</mat-icon>
        </button>
      </h1>
    </mat-dialog-content>
    <div style="display: flex; margin-left: 20px;">

      <form #Dateform="ngForm" style="display : inline-flex;width: 40em;">
        <label for="MinDate" class="col-sm-2 col-form-label">
          Minimum Date
        </label>
        <div class="col-sm-4" style="Padding: 2px !important">
          <!-- <p-calendar [(ngModel)]="model.MaxDate" [minDate]="mindate" [maxDate]="maxdate" [readonlyInput]="true" #maxDate="ngModel" id="MaxDate" name="MaxDate"></p-calendar> -->
          <mat-form-field appearance="outline" style="width: 90%;">
            <mat-label> Min Date</mat-label>
            <input required matInput [(ngModel)]="MinDate" #minDate="ngModel" id="MinDate" name="MinDate" [matDatepicker]="minpicker" style="font-size:14px;">
            <mat-datepicker-toggle matSuffix [for]="minpicker">
              <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
            </mat-datepicker-toggle>
            <mat-datepicker #minpicker></mat-datepicker>
          </mat-form-field>

        </div>
        <label for="MaxDate" class="col-sm-2 col-form-label">
          Maximum Date
        </label>
        <div class="col-sm-4">
          <!-- <p-calendar [(ngModel)]="model.MaxDate" [minDate]="mindate" [maxDate]="maxdate" [readonlyInput]="true" #maxDate="ngModel" id="MaxDate" name="MaxDate"></p-calendar> -->
          <mat-form-field appearance="outline" style="width: 90%;">
            <mat-label> Max Date</mat-label>
            <input required matInput [(ngModel)]="MaxDate" #maxDate="ngModel" id="MaxDate" name="MaxDate" [matDatepicker]="maxpicker" style="font-size:14px">
            <mat-datepicker-toggle matSuffix [for]="maxpicker">
              <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
            </mat-datepicker-toggle>
            <mat-datepicker #maxpicker></mat-datepicker>
          </mat-form-field>

        </div>
      </form>

      <div class="col-sm-2" style="display: flex;align-items: center;margin-bottom: 2em;">
        <button style="width: 54%; background-color: #2f72ab;" [disabled]="Dateform.invalid" class="btn btn-sm btn-primary mx-1" (click)="pull('pull')">Pull</button>
      </div>


    </div>

    <div class="row" style="width: 100%;">
      <div class="col">


        <table style="overflow: auto; padding: 0px; width: 100%; margin-left: 11px;" mat-table [dataSource]="TransactiondataSource" class="mat-elevation-z8">

          <!-- Checkbox Column -->
          <ng-container matColumnDef="select">
            <th mat-header-cell *matHeaderCellDef style="width:1%">
              <mat-checkbox (change)="$event ? masterToggle() : null"
                            [checked]="selection.hasValue() && isAllSelected()"
                            [indeterminate]="selection.hasValue() && !isAllSelected()"
                            [aria-label]="checkboxLabel()" color="primary">
              </mat-checkbox>
            </th>
            <td mat-cell *matCellDef="let row">
              <mat-checkbox (click)="$event.stopPropagation()"
                            (change)="$event ? selection.toggle(row) : null"
                            [checked]="selection.isSelected(row)"
                            [aria-label]="checkboxLabel(row)" color="primary">
              </mat-checkbox>
            </td>
          </ng-container>


          <ng-container matColumnDef="Transaction Date">
            <th style="width : 8%" mat-header-cell *matHeaderCellDef> Transaction<br /> Date </th>
            <td mat-cell *matCellDef="let element"> {{element.entryDate  | date:'shortDate'}} </td>
          </ng-container>

          <!-- Name Column -->
          <ng-container matColumnDef="Tracking/Invoice number">
            <th mat-header-cell *matHeaderCellDef style="width: 10%"> Tracking number </th>
            <td mat-cell *matCellDef="let element"> {{element.masterTrackingNumber}} </td>
          </ng-container>

          <!-- Weight Column -->
          <ng-container matColumnDef="Description of Charge">
            <th style="align-items: center; padding: 1%; width: 15%;" mat-header-cell *matHeaderCellDef> Charge Desc </th>
            <td mat-cell style="padding : 1%" *matCellDef="let element"> {{element.description}} </td>
          </ng-container>

          <ng-container matColumnDef="netAmount">
            <th mat-header-cell *matHeaderCellDef style="width: 10%;"> Customer Charge</th>
            <td style="width : 10%" mat-cell *matCellDef="let element">  <input style="width: 84%;" type="number" [(ngModel)]="element.netAmount" name="element.netAmount" />  </td>
          </ng-container>

          <ng-container matColumnDef="incentiveAmount">
            <th style="width : 10%;padding: 1%;text-align: center;" mat-header-cell *matHeaderCellDef> Invoiced Amount </th>
            <td style="padding: 1%;text-align: center;" *matCellDef="let element"> {{element.incentiveAmount}} </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="transactionColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: transactionColumns;">
          </tr>
        </table>
        <div style="display: block; margin-left: 11px; width: 100%;" class="notabledata" *ngIf="TransactiondataSource.data.length === 0">
          <div style="margin-top: 5px">No Data Available For Display<br /></div>
        </div>


        <mat-paginator #Transactionpaginator [length]="this.data?.length" [pageSizeOptions]="[5,10,50, 100]" aria-label="Select page of users" (page)="pageEvent = handlePageTop($event)"></mat-paginator>

      </div>

    </div>
    <div style="display: flex;justify-content: center;margin-top: 6vh;margin-bottom: 2%;">
      <!-- <button *ngIf = "Postaction == 'Pull'" [disabled] = "this.selection.selected.length==0 || model.status == 'Deleted'"type="button" (click)="getTransactions('Pull')" class="btn btn-sm btn-primary mx-1"> Add Transactions </button>
    <button *ngIf = "Postaction == 'load'" [disabled] = "this.selection.selected.length==0 || model.status == 'Deleted'" type="button" (click)="getTransactions('load')" class="btn btn-sm btn-primary mx-1"> Add Transactions </button> -->
      <button style="background-color: steelblue;" [disabled]="this.selection.selected.length==0 || model.status == 'Deleted'" type="button" (click)="getTransactions(Postaction)" class="btn btn-sm btn-primary mx-1"> Add Transactions </button>
    </div>
  </div>

</ng-template>



<p-dialog header="Title" modal="true" [(visible)]="showdiag" (onHide)="onDoagClose()">
  {{diagmsg}}
</p-dialog>
